import {
  ACTIVITY_STATUS,
  convertTimestampToBrazilianReadableText,
} from '@repo/ui';
import personIcon from 'presentation/app/assets/images/icon-person.jpeg';
import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

interface IColumns {
  studentName: string;
  studentPhoto?: string;
  internshipLocationName: string;
  taskName: string;
  scheduledTo: string;
  accomplishedAt: string;
  validatedAt: string;
  activityStatusId: number;
  activityStatusColor: string;
  validatedEventStatusId: number;
  activityStatusName: string;
}

const validatedEventStatusMap: Record<number, string> = {
  [ACTIVITY_STATUS.VALIDATED]: 'Validada',
  [ACTIVITY_STATUS.REJECTED]: 'Rejeitada',
};

export const makeColumnsPersonValidatedActivities =
  (): TableColumn<IColumns>[] => {
    return [
      {
        name: 'Nome do Estudante',
        selector: (row) => row.studentName,
        wrap: true,
        width: '15%',
        sortable: false,
        cell: (row) => (
          <div className="d-flex align-items-center gap-3 py-2">
            <img
              src={row?.studentPhoto || personIcon}
              alt="Foto da pessoa"
              className="avatar object-fit-cover"
            />
            <div className="d-flex flex-column">
              <span>
                <strong>{row?.studentName}</strong>
              </span>
            </div>
          </div>
        ),
      },
      {
        name: 'Local de Estágio',
        selector: (row) => row.internshipLocationName,
        sortable: false,
        wrap: true,
      },
      {
        name: 'Tarefa',
        selector: (row) => row.taskName,
        sortable: false,
        wrap: true,
      },
      {
        name: 'Agendado para',
        selector: (row) =>
          convertTimestampToBrazilianReadableText(row.scheduledTo),
        sortable: false,
        wrap: true,
      },
      {
        name: 'Realizado em',
        selector: (row) =>
          convertTimestampToBrazilianReadableText(row.accomplishedAt),
        sortable: false,
        wrap: true,
      },
      {
        name: 'Situação da Atividade',
        sortable: false,

        cell: (row) => {
          return (
            <Badge color={row.activityStatusColor}>
              {row.activityStatusName}
            </Badge>
          );
        },
      },
      {
        name: 'Validado em',
        selector: (row) =>
          convertTimestampToBrazilianReadableText(row.validatedAt),
        sortable: false,

        wrap: true,
      },
      {
        name: ' ',
        sortable: false,
        width: '7%',
        cell: (row) => {
          const isValidated =
            row.validatedEventStatusId === ACTIVITY_STATUS.VALIDATED;
          const badgeClass = isValidated
            ? 'badge bg-success-subtle text-success'
            : 'badge bg-danger-subtle text-danger';

          return (
            <span className={`${badgeClass} badge-border`}>
              {validatedEventStatusMap[row.validatedEventStatusId]}
            </span>
          );
        },
      },
    ];
  };
